module.exports = __webpack_public_path__ + "media/images/prizes__first-15ddb768324028ff1139f2873370d8e8.jpg";